import _assign from 'lodash/assign';
import ActionTypes from '../constants/ActionTypes';
import initialState from '../store/initialState';

export default (state = initialState.assessment, action) => {
  switch (action.type) {
    case `${ActionTypes.INIT_TEST}_SUCCESS`: {
      return _assign({}, state, action.payload);
    }
    case `${ActionTypes.CHECK_ENV_SETUP_STATUS}_SUCCESS`: {
      return {
        ...state,
        envSetup: { ...state.envSetup, isReady: action.payload.is_ready },
      };
    }
    case ActionTypes.IS_POD_BASED_PROBLEM: {
      return { ...state, isPodBased: action.payload };
    }
    case ActionTypes.INCREMENT_ENV_SETUP_RETRY: {
      return {
        ...state,
        envSetup: {
          ...state.envSetup,
          totalRetries: state.envSetup.totalRetries + 1,
        },
      };
    }
    default:
      return state;
  }
};
